<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <v-col cols="12">
      <base-material-card
        color="coolrunner"
        :icon="icon"
        inline
        class="px-5 py-3"
      >
        <template v-slot:after-heading>
          <v-col>
            <div class="text-h2 font-weight-light">
              {{ $t('delivery_morning') }}
            </div>

            <v-menu
              ref="date-menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              max-width="290px"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :color="date ? 'coolrunner': 'red'"
                  v-on="on"
                >
                  <div class="text-h4">
                    {{ date || $t('choose_delivery_date') }}
                  </div>
                </v-btn>
              </template>

              <v-date-picker
                v-model="date"
                :min="$moment().format('YYYY-MM-DD')"
              />
            </v-menu>
          </v-col>
        </template>

        <v-col style="text-align: center;">
          <v-col cols="12">
            <input
              v-model="code"
              style="font-size: 32px; border: 2px solid grey; padding: 10px 5px; width: 100%; border-radius: 10px; text-align: center"
              :placeholder="$t('enter_package_number')"
              @keypress.enter="scan"
            >
          </v-col>

          <v-btn
            class="mt-2 ml-auto"
            color="primary"
            large
            :disabled="!code || loading"
            :loading="loading"
            @click="scan"
          >
            {{ $t('scan') }}
          </v-btn>
          <v-col
            cols="4"
          >
            <v-card
              v-if="!$_.isEmpty(latestScan)"
              inline
              class="px-5 py-3"
              color="coolrunner"
            >
              <h2 style="text-align: left; color: white;">
                {{ $t('latest_scan') }}
              </h2>
              <v-col>
                <p
                  style="text-align: left; font-size: 18px; color: white;"
                  class="mb-2 mt-0"
                >
                  {{ latestScan.package_number }}
                </p>

                <p
                  style="text-align: left; font-size: 18px; color: white;"
                  class="mb-1"
                >
                  {{ latestScan.receiver.name }}
                </p>
                <p
                  style="text-align: left; color: white;"
                  class="mb-0"
                >
                  {{ latestScan.receiver.street1 }}
                </p>
                <p
                  style="text-align: left; color: white;"
                  class="mb-0"
                >
                  {{ latestScan.receiver.zip_code }} {{ latestScan.receiver.city }}
                </p>
                <p
                  style="text-align: left; color: white;"
                  class="mb-0"
                >
                  {{ latestScan.phone }}
                </p>
              </v-col>
            </v-card>
          </v-col>
        </v-col>
      </base-material-card>

      <base-material-card
        color="coolrunner"
        :icon="icon"
        inline
        class="px-5 py-3"
      >
        <template v-slot:after-heading>
          <v-row>
            <v-col>
              <div class="text-h2 font-weight-light">
                {{ $t('scanned_packages') }}
              </div>
              <div class="font-weight-light">
                {{ `${$t('count')}: ${staged.length}` }}
              </div>
            </v-col>
            <v-col style="text-align: right;">
              <v-btn
                color="coolrunner"
                :disabled="!date || !staged.length || exporting"
                @click="exportData"
              >
                {{ $t('export') }}
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <v-data-table
          :items="staged"
          :headers="headers"
          dense
          :options.sync="stagedOptions"
          :server-items-length="totalStaged"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50, 100]
          }"
          :loading="loadingStaged"
          item-key="route"
        >
          <template v-slot:item.actions="{item}">
            <v-icon
              medium
              class="mr-2"

              color="green"
              @click="getLabel(item.package_number)"
            >
              mdi-receipt
            </v-icon>
            <v-icon
              medium
              color="red"
              :disabled="unscanning == item.packageNumber"
              @click="removeLabel(item.package_number)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </base-material-card>
      <base-material-card
        color="coolrunner"
        :icon="icon"
        inline
        class="px-5 py-3"
      >
        <template v-slot:after-heading>
          <v-row>
            <v-col>
              <div class="text-h2 font-weight-light">
                {{ $t('exported_packages') }}
              </div>
            </v-col>
          </v-row>
        </template>
        <v-data-table
          :items="exported"
          :headers="headers"
          dense
          :options.sync="exportedOptions"
          :server-items-length="totalExported"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50, 100]
          }"
          :loading="loadingExported"
          item-key="route"
        >
          <template v-slot:item.actions="{item}">
            <v-icon
              medium
              class="mr-2"

              color="green"
              @click="getLabel(item.package_number)"
            >
              mdi-receipt
            </v-icon>
          </template>
        </v-data-table>
      </base-material-card>
    </v-col>
    <base-loading-overlay :loading="loadingPdf || exporting" />
  </v-container>
</template>

<script>
  import Auth from '@/mixins/Auth'
  import { handleErrorResponse } from '@/plugins/data'
  import print from 'print-js'
  import { PCN } from '../../utils/constants'

  export default {
    name: 'HomeRunnerEarlyScan',
    mixins: [Auth],
    data () {
      return {
        crudl: {
          C: PCN.val,
          R: PCN.val,
          U: PCN.val,
          D: PCN.val,
          L: PCN.val,
          COOLRUNNER_ONLY: false,
        },
        now: Date.now(),

        endpoint: 'homerunner/early',
        name: 'homerunner',
        dateMenu: false,
        date: null,
        icon: 'mdi-truck-fast-outline',
        code: '',
        headers: [
          {
            sortable: false,
            text: this.$t('package_number'),
            value: 'package_number',
          },
          {
            sortable: false,
            align: 'center',

            text: this.$t('name'),
            value: 'shipment.receiver.name',
          },
          {
            sortable: false,
            align: 'center',
            text: this.$t('zip_code'),
            value: 'shipment.receiver.zip_code',
          },
          {
            sortable: false,
            align: 'center',
            text: this.$t('scanned_at'),
            value: 'scanned_terminal_at_local',
          },
          {
            sortable: false,
            align: 'center',
            text: this.$t('delivery_date'),
            value: 'delivery_date_local',
          },
          {
            sortable: false,

            width: '100%',
            align: 'right',

            value: 'actions',
          },
        ],
        staged: [
        ],
        totalStaged: 0,
        exported: [
        ],
        totalExported: 0,
        loading: false,
        loadingPdf: false,
        loadingStaged: false,
        loadingExported: false,
        exporting: false,
        unscanning: false,
        stagedOptions: {
          itemsPerPage: 20,
          page: 1,
        },
        exportedOptions: {
          itemsPerPage: 20,
          page: 1,
        },
        latestScan: null,
      }
    },
    computed: {
      stagedParams: function () {
        return {
          limit: this.stagedOptions.itemsPerPage,
          page: this.stagedOptions.page,
        }
      },
      exportedParams: function () {
        return {
          limit: this.exportedOptions.itemsPerPage,
          page: this.exportedOptions.page,
        }
      },

    },
    watch: {
      date: function () {
        this.getStaged()
        this.getExported()
      },
      now: function () {
        const tomorrow = this.$moment().add(1, 'days').format('YYYY-MM-DD')

        if ((this.$moment() === 3 && this.date !== tomorrow) || !this.date) {
          this.date = tomorrow
        }
      },
    },
    created: function () {
      this.$moment().add(1, 'days').format('YYYY-MM-DD')
      setInterval(() => {
        this.now = Date.now()
      }, 1000)
    },
    methods: {
      scan: function () {
        if (this.loading) { return }
        if (!this.date) {
          alert(this.$t('homerunner_early.please_choose_date'))
          return
        }
        if (!this.code || this.code.length === 0) { return }
        this.loading = true
        this.latestScan = null

        if (this.code.length === 8 && !isNaN(this.code)) {
          const chunks = this.code.match(/.{1,2}/g)
          this.code = `HR-${chunks.join('-')}`
        }

        this.$get(`${this.endpoint}/scan/${this.code}/${this.date}`)
          .then(({ data }) => {
            this.latestScan = data.shipment
            if (data.relabel) {
              this.getLabel(this.code)
            }

            this.staged = data.paginator.data
            this.totalStaged = data.paginator.total

            this.code = ''
            this.$playSound('/sounds/success.mp3')
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },
      getLabel: function (packageNumber) {
        this.loadingPdf = `${this.$t('fetching_label')}...`
        this.$get(`${this.endpoint}/label/${packageNumber}`, {}, { responseType: 'blob' })
          .then(r => {
            print({
              printable: URL.createObjectURL(r.data),
              type: 'pdf',

              onPrintDialogClose: () => { this.loadingPdf = null },
              onPdfOpen: () => { this.loadingPdf = null },
              onError: handleErrorResponse,
            })
          })
          .catch(e => {
            this.loadingPdf = null
          })
      },

      getStaged: function () {
        if (!this.date) { return }
        this.loadingStaged = true
        this.$get(`${this.endpoint}/staged/${this.date}`, this.stagedParams).then(({ data }) => {
          this.staged = data.data
          this.totalStaged = data.total
        })
          .finally(r => {
            this.loadingStaged = false
          })
      },
      getExported: function () {
        if (!this.date) { return }

        this.loadingExported = true
        this.$get(`${this.endpoint}/exported/${this.date}`, this.exportedParams).then(({ data }) => {
          this.exported = data.data
          this.totalExported = data.total
        })
          .finally(r => {
            this.loadingExported = false
          })
      },
      exportData: function () {
        if (!this.date) { return }

        this.exporting = true

        this.$get(`${this.endpoint}/export/${this.date}`).then(({ data }) => {
          console.log(data.staged)
          this.exported = data.exported.data
          this.totalExported = data.exported.total

          this.staged = data.staged.data
          this.totalStaged = data.staged.total
        })
          .finally(r => {
            this.exporting = false
          })
      },

      removeLabel: function (packageNumber) {
        if (!confirm(this.$t('homerunner_early.confirm_delete'))) { return }

        if (!this.date) { return }

        this.unscanning = packageNumber

        this.$get(`${this.endpoint}/unscan/${packageNumber}/${this.date}`).then(({ data }) => {
          this.staged = data.data
          this.totalStaged = data.total
        })
          .finally(r => {
            this.unscanning = false
          })
      },

    },
  }
</script>
